module.exports = __webpack_public_path__ + "img/bordeaux-logo-icon.fef908f7.png";